/** @format */

import { isPlatformBrowser } from '@angular/common';
import { Directive, HostBinding, Input, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { DirectiveStylesService } from '../services/directive-styles.service';

const STYLE_DARK = `
		.force-show-scrollbars ::-webkit-scrollbar {
			-webkit-appearance: none;
			background-color: transparent;
			width: 10px;
		}

		.force-show-scrollbars ::-webkit-scrollbar-thumb {
			background-clip: padding-box;
			background-color: #333;
			border-color: transparent;
			border-radius: 9px 8px 8px 9px;
			border-style: solid;
			border-width: 3px 3px 3px 4px; /* Workaround because margins aren't supported */
		}

		/* Unfortunately scrollbars can't use CSS transitions. Also, it's not possible
		to highlight the thumb when the scrollbar track is hovered without some
		JavaScript acrobatics; https://jsfiddle.net/QcqBM/6/ is a start, but you
		also have to check whether the element has a scrollbar and if so how wide
		it is. */
		.force-show-scrollbars ::-webkit-scrollbar-thumb:hover {
			background-color: rgba(#C8C8C8, 0.5);
	}`;

const STYLE_LITE = `
	.force-show-scrollbars ::-webkit-scrollbar {
		-webkit-appearance: none;
		background-color: transparent;
		width: 10px;
	}

	.force-show-scrollbars ::-webkit-scrollbar-thumb {
		background-clip: padding-box;
		background-color: #C8C8C8;
		border-color: transparent;
		border-radius: 9px 8px 8px 9px;
		border-style: solid;
		border-width: 3px 3px 3px 4px; /* Workaround because margins aren't supported */
	}

	/* Unfortunately scrollbars can't use CSS transitions. Also, it's not possible
	to highlight the thumb when the scrollbar track is hovered without some
	JavaScript acrobatics; https://jsfiddle.net/QcqBM/6/ is a start, but you
	also have to check whether the element has a scrollbar and if so how wide
	it is. */
	.force-show-scrollbars ::-webkit-scrollbar-thumb:hover {
		background-color: rgba(#F9F9F9, 0.5);
	}`;

@Directive({
  selector: '[homeUtilsCommonScrollbars]',
  standalone: false,
})
export class ScrollbarsDirective implements OnInit {
  @HostBinding('class.force-show-scrollbars') showScrollbars = false;
  @Input('homeUtilsCommonScrollbars') scrollbarLogic: boolean;
  @Input() darkTheme = false;

  protected readonly platformId = inject(PLATFORM_ID);
  public readonly directiveStyles = inject(DirectiveStylesService);
  /* istanbul ignore next */
  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && this.scrollbarLogic && !this.areScrollbarsVisible()) {
      this.showScrollbars = true;
      this.directiveStyles.addStyle(this.darkTheme ? STYLE_DARK : STYLE_LITE, 'ScrollbarDirective');
    }
  }

  /* istanbul ignore next */
  areScrollbarsVisible() {
    const scrollableElem = document.createElement('div');
    const innerElem = document.createElement('div');
    scrollableElem.style.width = '30px';
    scrollableElem.style.height = '30px';
    scrollableElem.style.overflow = 'scroll';
    scrollableElem.style.borderWidth = '0';
    innerElem.style.width = '30px';
    innerElem.style.height = '60px';
    scrollableElem.appendChild(innerElem);
    document.body.appendChild(scrollableElem); // Elements only have width if they're in the layout
    const diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
    document.body.removeChild(scrollableElem);
    return diff > 0;
  }
}
